import Vue from "vue";
import App from "./App.vue";
import Keycloak from "keycloak-js";
import axios from "axios";
import vuetify from "./plugins/vuetify";

const {
  VUE_APP_KC_CLIENT_ID: clientId,
  VUE_APP_KC_REALM: realm,
  VUE_APP_KC_URL: url
} = process.env;

Vue.config.productionTip = false;

const kc = Keycloak({
  url,
  realm,
  clientId
});

kc.init({
  onLoad: "login-required",
  promiseType: "native"
}).then(async authenticated => {
  const { attributes } = await kc.loadUserProfile();
  const { LDAP_ENTRY_DN } = attributes;
  const ou = LDAP_ENTRY_DN[0]
    .split(",")
    .filter(x => x.indexOf("OU=") > -1)[1]
    .replace("OU=", "");

  if (authenticated && ou === "Personnel") {
    new Vue({
      vuetify,
      render: h => h(App, { props: { keycloak: kc } })
    }).$mount("#app");
  } else {
    kc.logout();
  }
});

axios.interceptors.request.use(config =>
  kc
    .updateToken(5)
    .then(() => {
      config.headers.Authorization = "Bearer " + kc.token;
      return Promise.resolve(config);
    })
    .catch(() => {
      kc.login();
    })
);
